import { get, post } from 'api/request'

export const API_ACTION_SCRIPT = "/operator/service/action-script"

export const getActionScriptList = () => get(`${API_ACTION_SCRIPT}`)
export const runActionScript = (key, conversationData, defaults) => post(
  `${API_ACTION_SCRIPT}/${key}/run`,
  { conversation: conversationData, defaults }
)
